import React from "react";
import { Container } from "components";
import { useNavigate } from "react-router-dom";
import "./PaymentSuccess.css";

const PaymentSuccess = () => {
  const navigate = useNavigate();

  const handleNewSite = () => {
    navigate("/plans");
  };

  const handleBackHome = () => {
    navigate("/enrolledPlans");
  };

  return (
    <Container>
      <div className="content-wrapper">
        <div className="container-xxl flex-grow-1 container-p-y">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="card payment-success-card">
                <div className="card-body p-3">
                  <div className="row align-items-center">
                    {/* Left side - Content */}
                    <div className="col-lg-6">
                      <div className="text-center text-lg-start">
                        <h1 className="payment-success-title">
                          Payment successful
                        </h1>

                        <p className="payment-success-message">
                          Thank you for choosing Zenosure.
                        </p>

                        {/* Progress Steps */}
                        <div className="mb-4">
                          <div className="progress-step">
                            <div className="progress-icon success">
                              <i className="fas fa-check"></i>
                            </div>
                            <span className="progress-text success">
                              Plan selected
                            </span>
                          </div>

                          <div className="progress-step">
                            <div className="progress-icon success">
                              <i className="fas fa-check"></i>
                            </div>
                            <span className="progress-text success">
                              Payment received
                            </span>
                          </div>

                          <div className="progress-step">
                            <div className="progress-icon pending">
                              <i className="fas fa-file-alt"></i>
                            </div>
                            <span className="progress-text pending">
                              KYC verification
                            </span>
                          </div>
                        </div>

                        {/* Action Buttons */}
                        <div className="action-buttons">
                          <button
                            className="btn btn-lg px-4 btn-outline-success-custom"
                            onClick={handleBackHome}
                          >
                            Back Home
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Right side - Illustration */}
                    <div className="col-lg-6">
                      <div className="illustration-container">
                        <img
                          src="/assets/img/illustrations/boy-with-rocket-dark.png"
                          alt="Payment Success"
                          className="illustration-image"
                        />

                        {/* Confetti effect */}
                        <div
                          className="confetti red"
                          style={{ top: "10%", left: "20%" }}
                        ></div>
                        <div
                          className="confetti blue"
                          style={{ top: "15%", right: "25%" }}
                        ></div>
                        <div
                          className="confetti yellow"
                          style={{ top: "25%", left: "15%" }}
                        ></div>
                        <div
                          className="confetti green"
                          style={{ top: "20%", right: "15%" }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default PaymentSuccess;
